import { render } from "./BuzzMentionInput.vue?vue&type=template&id=2ff6cca7&scoped=true"
import script from "./BuzzMentionInput.vue?vue&type=script&lang=js"
export * from "./BuzzMentionInput.vue?vue&type=script&lang=js"

import "./buzz-mention-input.scss?vue&type=style&index=0&id=2ff6cca7&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff6cca7"]])

export default __exports__